export const validate_polygon = (lines: any, dropDownState: any) => {
    // if extrapolation is off return valid
    if (dropDownState !== 'extrapolation') {
        return { valid: true, description: '' }
    } else {
        // check if polygon provided
        if (lines.length === 0) {
            return { valid: false, description: 'please provide a polygon' }
        }

        //check if a reference line has been provided
        let start: any = null
        lines.every((element: any, index: any) => {
            if (element.ref === true) {
                start = index
                return false
            }
            return true
        })
        if (start === null) {
            return {
                valid: false,
                description: 'please provide at least one line with a reference tag'
            }
        }

        //validate if reference lines are next to each other
        let i = start
        let end = false
        let true_continue = false
        let valid = true
        lines.every((element: any, index: number, array: any) => {
            if (i === lines.length) {
                i = 0
            }
            if (array[i].ref === false && end && true_continue) {
                valid = false
            }
            if (array[i].ref === true && end) {
                true_continue = true
            }
            if (array[i].ref === false) {
                end = true
            }
            i++
            return true
        })
        return {
            valid: valid,
            description: 'reference lines have to be connected'
        }
    }
}
